function startLoading() {
  if (!$('.loader').length) {
    $('body').append('<div class="loader"></div>');
  }
}

function showHideInfoExtra(qual) {
  var icone_expandir = $('#icone-expandir' + qual);
  var dados_extras = $('#dados-extras' + qual);

  if (icone_expandir.hasClass('fa-caret-right')) {
    dados_extras.show();
    icone_expandir.parent().attr('title', 'Fechar');
    icone_expandir.removeClass('fa-caret-right');
    icone_expandir.addClass('fa-caret-down');
  } else { //aberto
    dados_extras.hide();
    icone_expandir.parent().attr('title', 'Detalhar');
    icone_expandir.removeClass('fa-caret-down');
    icone_expandir.addClass('fa-caret-right');
  }
}

function stateValuesOnFilters(oSettings) {
  var cols = oSettings.aoPreSearchCols;
  for (var i = 0; i < cols.length; i++) {
    var value = cols[i].sSearch;
    if (value.length > 0) {
      $($("tfoot th")[i]).find('input:not([type="checkbox"])').val(value);
      $($("tfoot th")[i]).find('select').val(value);
      $($("tfoot th")[i]).find('select').trigger('change');
    }
  }
}

function collapse() {
  $body.on('click', '.js-collapse', function(event) {
    var button = event.currentTarget;
    var target = document.querySelector(button.dataset.target);
    var icon = button.querySelector('i.fa');

    target.classList.toggle('hidden');

    var current_icon = target.classList.contains('hidden') ? 'fa-plus' : 'fa-minus';

    icon.classList.remove('fa-plus');
    icon.classList.remove('fa-minus');

    icon.classList.add(current_icon);
  });
}

function stopLoading() {
  if ($('.loader').length) {
    $('.loader').fadeToggle(function() {
      $(this).remove();
    });
  }
}

var mascara = function(val) {
    return val.replace(/\D/g, '').length === 14 ? '(00) 00000-0000' : '(00) 0000-00009';
  },
  options = {
    onKeyPress: function(val, e, field, options) {
      field.mask(mascara.apply({}, arguments), options);
    }
  };

function htmlEditorTags($tags) {
  $('.htmleditorTags').summernote({
    toolbar: [
      ['style', ['style']],
      ['font', ['bold', 'italic', 'underline', 'clear']],
      ['fontname', ['fontname']],
      ['fontsize', ['fontsize']],
      ['color', ['color']],
      ['para', ['ul', 'ol', 'paragraph']],
      ['height', ['height']],
      ['table', ['table']],
      ['insert', ['link', 'hr', 'picture']],
      ['view', ['fullscreen', 'codeview']],
      ['help', ['help']]
    ],
    lang: 'pt-BR',
    cleaner: {
      notTime: 2400, // Time to display Notifications.
      action: 'both', // both|button|paste 'button' only cleans via toolbar button, 'paste' only clean when pasting content, both does both options.
      newline: '<br>', // Summernote's default is to use '<p><br></p>'
      notStyle: 'position:absolute;top:0;left:0;right:0', // Position of Notification
      // icon:'<i class="note-icon">[Your Button]</i>'
      keepHtml: false, //Remove all Html formats
      keepClasses: false, //Remove Classes
      badTags: ['style', 'script', 'applet', 'embed', 'noframes', 'noscript', 'html'], //Remove full tags with contents
      badAttributes: ['style', 'start'] //Remove attributes from remaining tags
    },
    hint: {
      mentions: $tags,
      match: /\B\[(\w*)$/,
      search: function (keyword, callback) {
        callback($.grep(this.mentions, function (item) {
          keyword = keyword.toUpperCase();
          return item.indexOf(keyword) == 0;
        }));
      },
      content: function (item) {
        return $('<span><span style="background-color:limegreen;">[' + item + ']</span>&nbsp;</span>')[0];
      }
    }
  });
}

function setDataTableUrl(url, refresh) {
    refresh = typeof refresh !== 'undefined' ? refresh : true;
  if (typeof LaravelDataTables !== 'undefined') {
    var table = LaravelDataTables.dataTableBuilder
    table.ajax.url(url);
    refresh && table.draw();
    history.replaceState({}, '', url);
  }
}

$(function() {
  var hash = location.hash
      , hashPieces = hash.split('?');
  if(hashPieces[0]!=""){
      activeTab = $('[href="' + hashPieces[0] + '"]');
      activeTab && activeTab.tab('show');
  }

  // Remove título do select dois ao trocar a seleção
  $('.select2').on('change', function(evt) {
    $('.select2-selection__rendered').removeAttr('title');
  });

    $('.js-disable-enter').on('keyup keypress', function(e) {
        var keyCode = e.keyCode || e.which;
        if (keyCode === 13) {
            e.preventDefault();
            return false;
        }
    });

  menu();
  collapse();
  icheck('input:not(.btn > input):not(.no-icheck)');

  $.ajaxSetup({
    headers: {
      'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
  });

  initSelect2();

  $('[data-toggle="tab"].js-tooltip').tooltip({
    trigger: 'hover',
    placement: 'top',
    animate: true,
    container: 'body'
  });

  $('.colorbox').colorbox({
    transition: "fade",
    width: "95%",
    height: "95%"
  });


  $('.colorbox-photo').colorbox({
    photo: true,
    transition: "fade",
    width: "95%",
    height: "95%"
  });

  $('form:not(.js-no-overlay)').submit(function(event) {
    $('.box.box-primary').append('<div class="overlay"><i class="fa fa-refresh fa-spin"></i></div>');
  });

  $('.money').maskMoney({
    allowNegative: true,
    thousands: '.',
    decimal: ',',
    allowZero:true
  });

  $(".modal").on('show.bs.modal', function () {
    $('.money').maskMoney({
      allowNegative: true,
      thousands: '.',
      decimal: ',',
      allowZero:true
    });
  });

  $(".decimal4").maskMoney({
    allowNegative: true,
    allowZero: true,
    thousands: '.',
    decimal: ',',
    precision: 4
  });

  $(".decimal6").maskMoney({
    allowNegative: true,
    allowZero: true,
    thousands: '.',
    decimal: ',',
    precision: 6
  });

  $('.money_3').mask('0.000.000.000.000,000', {
    reverse: true
  });
  $('.decimal').mask('00,00');
  $('.percent').mask('#00,00', {
    reverse: true
  });

  $('.datepicker').datepicker();

  if (!Modernizr.inputtypes.date) {
    $('input[type=date]').each(function(index, obj) {
      var data = $(obj).val();
      if (data != '' && (data.indexOf('-') > 1)) {
        var ano = data.substring(0, 4);
        var mes = data.substring(5, 7);
        var dia = data.substring(8, 10);
        var data_formatada = dia + '/' + mes + '/' + ano;

        $(obj).val(data_formatada);
      }
    });

    $('input[type=date]')
      .attr('type', 'text')
      .attr('readonly', 'readonly')
      .datepicker({
        format: 'dd/mm/yyyy',
        language: 'pt-BR'
      });
  }

  if (!Modernizr.inputtypes.month) {
    $('input[type=month]')
    .attr('type', 'text')
    .attr('readonly', 'readonly')
    .datepicker({
      format: 'yyyy-mm',
      changeMonth: true,
      changeYear: true,
      showButtonPanel: true,
      dateFormat: 'yy-mm',
      onClose: function(dateText, inst) {
        $(this).datepicker('setDate', new Date(inst.selectedYear, inst.selectedMonth, 1));
      }
    });
  }

  $('.data_br').mask('99/99/9999');
  $('.cnpj').mask('99.999.999/9999-99');
  $('.cep').mask('00000-000');
  $('.rg').mask('99.999.999-9');
  $('.cpf').mask('999.999.999-99');
  $('.hora').mask('99:99');
  $('.telefone').mask(mascara, options);
  $('.pis').mask('999.99999.99-9');

  var popoverOptions = {
    html: true,
    content: function() {
      var content = $(this.dataset.externalContent);
      if (content.length) {
        return content.html();
      }

      return this.dataset.content;
    }
  };

  $('[data-toggle="popover"]').popover(popoverOptions);

  $document.on('draw.dt', function() {
    $('[data-toggle="popover"]').popover(popoverOptions);
    if (isMobile()) {
      $('.dataTable td > form .btn-group')
        .removeClass('btn-group')
        .find('.btn')
        .removeClass('btn-xs')
        .addClass('btn-sm');
    }
  });

  $('.htmleditor').summernote({
    toolbar: [
      ['style', ['style']],
      ['font', ['bold', 'italic', 'underline', 'clear']],
      ['fontsize', ['fontsize']],
      ['color', ['color']],
      ['para', ['ul', 'ol', 'paragraph']],
      ['height', ['height']],
      ['table', ['table']],
      ['insert', ['link', 'hr', 'picture']],
      ['view', ['fullscreen', 'codeview']],
      ['help', ['help']]
    ],
    lang: 'pt-BR',
    cleaner: {
      notTime: 2400, // Time to display Notifications.
      action: 'both', // both|button|paste 'button' only cleans via toolbar button, 'paste' only clean when pasting content, both does both options.
      newline: '<br>', // Summernote's default is to use '<p><br></p>'
      notStyle: 'position:absolute;top:0;left:0;right:0', // Position of Notification
      // icon:'<i class="note-icon">[Your Button]</i>'
      keepHtml: false, //Remove all Html formats
      keepClasses: false, //Remove Classes
      badTags: ['style', 'script', 'applet', 'embed', 'noframes', 'noscript', 'html'], //Remove full tags with contents
      badAttributes: ['style', 'start'] //Remove attributes from remaining tags
    }
  });

  $(".selecionavel").on('mouseup', function() {
    var sel, range;
    var el = $(this)[0];
    if (window.getSelection && document.createRange) { //Browser compatibility
      sel = window.getSelection();
      if (sel.toString() == '') { //no text selection
        window.setTimeout(function() {
          range = document.createRange(); //range object
          range.selectNodeContents(el); //sets Range
          sel.removeAllRanges(); //remove all ranges from selection
          sel.addRange(range); //add Range to a Selection.
        }, 1);
      }
    } else if (document.selection) { //older ie
      sel = document.selection.createRange();
      if (sel.text == '') { //no text selection
        range = document.body.createTextRange(); //Creates TextRange object
        range.moveToElementText(el); //sets Range
        range.select(); //make selection.
      }
    }
  });

  $document.on('click', function(e) {
    $('[data-toggle="popover"],[data-original-title]').each(function() {
      if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
        (($(this).popover('hide').data('bs.popover') || {}).inState || {}).click = false // fix for BS 3.3.6
      }
    });
  });

  window.scrollTo(0, 0);

});

/**
 * Transforms money string (9.999,9) to float
 *
 * @param {String} money
 *
 * @return {Number}
 */
function moneyToFloat(money) {
  return parseFloat(money.replace(/\./g, '').replace(',', '.'), 10);
}

/**
 * Transforms money string (9.999,9) to float
 *
 * @param {Number} number
 *
 * @return {String}
 */
function floatToMoney(number, prefix, precision) {
  prefix = prefix == undefined ? 'R$ ' : prefix;
  precision = precision == undefined ? 2 : precision;
  return prefix + number.toLocaleString('pt-BR', {
    minimumFractionDigits: precision,
    maximumFractionDigits: precision
  });
}

/**
 * Transforms money string (9.999,9) to float
 *
 * @param {Number} number
 *
 * @return {String}
 */
function floatToMoney6(number, prefix) {
  prefix = prefix == undefined ? 'R$ ' : prefix;
  return prefix + number.toLocaleString('pt-BR', {
    minimumFractionDigits: 6,
    maximumFractionDigits: 6
  });
}

/**
 * Remove tudo que não for número
 *
 * @param {String} string
 *
 * @return {Number}
 */
function removeNaoNumero(str) {
  return parseInt(str.replace(/[\D]+/g, ''));
}

/**
 * Tranforma o parâmetro em formato de moeda Real
 *
 * @param {Integer} integer
 *
 * @return {String}
 */
function formatarReal(int) {
  var tmp = int + '';
  tmp = tmp.replace(/\D/g, '');
  tmp = tmp.replace(/(\d{1,2})$/, ',$1');
  tmp = tmp.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
  tmp = tmp != '' ? tmp : '';

  return tmp;
}

var oTable = null;

window.$body = $(document.body);
window.$document = $(document);

/* Brazilian initialisation for the jQuery UI date picker plugin. */
/* Written by Leonildo Costa Silva (leocsilva@gmail.com). */
jQuery(function($) {
  $.datepicker.regional['pt-BR'] = {
    closeText: 'Fechar',
    prevText: '&#x3c;Anterior',
    nextText: 'Pr&oacute;ximo&#x3e;',
    currentText: 'Hoje',
    monthNames: ['Janeiro', 'Fevereiro', 'Mar&ccedil;o', 'Abril', 'Maio', 'Junho',
      'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
    ],
    monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun',
      'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'
    ],
    dayNames: ['Domingo', 'Segunda-feira', 'Ter&ccedil;a-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sabado'],
    dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
    dayNamesMin: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
    weekHeader: 'Sm',
    dateFormat: 'dd/mm/yy',
    firstDay: 0,
    isRTL: false,
    showMonthAfterYear: false,
    yearSuffix: ''
  };
  $.datepicker.setDefaults($.datepicker.regional['pt-BR']);
});

function validarCNPJ(cnpj) {

  cnpj = cnpj.replace(/[^\d]+/g, '');

  if (cnpj == '') return false;

  if (cnpj.length != 14)
    return false;

  // Elimina CNPJs invalidos conhecidos
  if (cnpj == "00000000000000" ||
    cnpj == "11111111111111" ||
    cnpj == "22222222222222" ||
    cnpj == "33333333333333" ||
    cnpj == "44444444444444" ||
    cnpj == "55555555555555" ||
    cnpj == "66666666666666" ||
    cnpj == "77777777777777" ||
    cnpj == "88888888888888" ||
    cnpj == "99999999999999")
    return false;

  // Valida DVs
  tamanho = cnpj.length - 2
  numeros = cnpj.substring(0, tamanho);
  digitos = cnpj.substring(tamanho);
  soma = 0;
  pos = tamanho - 7;
  for (i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2)
      pos = 9;
  }
  resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
  if (resultado != digitos.charAt(0))
    return false;

  tamanho = tamanho + 1;
  numeros = cnpj.substring(0, tamanho);
  soma = 0;
  pos = tamanho - 7;
  for (i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2)
      pos = 9;
  }
  resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
  if (resultado != digitos.charAt(1))
    return false;

  return true;

}

function initSelect2() {
  $('.select2').each(function(n, el) {
    var $el = $(el);

    var parent = $el.parent();
    var select = parent.find('select');
    if (select.hasClass('ignore_init')) {
      return true;
    }

    var placeholder = $el.find('[value=""]').first().text()
      || $el.prop('placeholder')
      || $el.data('placeholder')
      || '-';

    $el.select2({
      placeholder: placeholder,
      language: "pt-BR",
      allowClear: true
    });
  });
}

function recarregaMascara() {
  $('.money').maskMoney({
    allowNegative: false,
    thousands: '.',
    decimal: ','
  });

  initSelect2();
}

function menu() {
  var hamburger = document.querySelector('.hamburger');

  hamburger && hamburger.addEventListener('click', function(e) {
    hamburger.classList.toggle('is-active');
  });

  return hamburger;
}

function icheck(selector) {
  return $(selector).iCheck({
    checkboxClass: 'icheckbox_minimal-grey',
    radioClass: 'iradio_minimal-grey',
  });
}

function salvarQtdMinima(qtd, insumo_id, obra_id) {
  $.ajax('/gestao-de-estoque/estoque-minimo/salvar', {
    data: {
      qtd: qtd,
      insumo_id: insumo_id,
      obra_id: obra_id
    }
  }).done(function () {
    window.LaravelDataTables["dataTableBuilder"].draw();

    $(document).on('draw.dt', function() {
      recarregaMascara();
    });
  });
}

function DoubleScroll(element) {
    scrollbar = document.createElement('div');
    scrollbar.appendChild(document.createElement('div'));
    scrollbar.setAttribute('id', 'div_double');
    scrollbar.style.overflow = 'auto';
    scrollbar.style.overflowY = 'hidden';
    scrollbar.firstChild.style.width = element.scrollWidth+'px';
    scrollbar.firstChild.style.paddingTop = '1px';
    scrollbar.firstChild.appendChild(document.createTextNode('\xA0'));
    scrollbar.onscroll = function() {
        element.scrollLeft = scrollbar.scrollLeft;
    };
    element.onscroll = function() {
        scrollbar.scrollLeft = element.scrollLeft;
    };
    element.parentNode.insertBefore(scrollbar, element);
}

function expandeEncolhe(qual) {
    if($('#'+qual+' .box-body').is(':visible')){
        $('#'+qual+' .box-body').hide();
        $('#'+qual+' .iconeExpandeEncolhe').removeClass('fa-minus');
        $('#'+qual+' .iconeExpandeEncolhe').addClass('fa-plus');
    }else{
        $('#'+qual+' .box-body').show();
        $('#'+qual+' .iconeExpandeEncolhe').removeClass('fa-plus');
        $('#'+qual+' .iconeExpandeEncolhe').addClass('fa-minus');
    }

}

// Manter barra lateral fechada ou aberta conforme escolha do usuário
$.AdminLTESidebarTweak = {};

$.AdminLTESidebarTweak.options = {
    EnableRemember: true,
    NoTransitionAfterReload: true
    //Removes the transition after page reload.
};

function genericAjaxErrorMessage(initial) {
  return (initial ? initial : 'Não foi possível realizar a operação, tente novamente.')
    + ' Se erro persistir entrar em contato com o suporte (v.link.suporte@vittaresidencial.com.br).'
}

$(function () {
    "use strict";

    $("body").on("collapsed.pushMenu", function() {
        if($.AdminLTESidebarTweak.options.EnableRemember) {
            localStorage.setItem("toggleState", "closed");
        }
    });

    $("body").on("expanded.pushMenu", function() {
        if($.AdminLTESidebarTweak.options.EnableRemember) {
            localStorage.setItem("toggleState", "opened");
        }
    });

    if ($.AdminLTESidebarTweak.options.EnableRemember) {
        var toggleState = localStorage.getItem("toggleState");
        if (toggleState == 'closed'){
            if ($.AdminLTESidebarTweak.options.NoTransitionAfterReload) {
                $("body").addClass('sidebar-collapse hold-transition').delay(100).queue(function() {
                    $(this).removeClass('hold-transition');
                });
            } else {
                $("body").addClass('sidebar-collapse');
            }
        }
    }
});

function showHide(obj) {
    $('#'+obj).toggle();
}

function formatSelectResultSelection (obj) {
    if(obj.nome){
        return obj.nome;
    }
    return obj.text;
}

function formatSelectResult (obj) {
  if (obj.loading) return obj.text;

  var markup_insumo =    "<div class='select2-result-obj clearfix'>" +
          "   <div class='select2-result-obj__meta'>" +
          "       <div class='select2-result-obj__title'>" + obj.nome + "</div>"+
          "   </div>"+
          "</div>";

  return markup_insumo;
}

function iniciaSelect2(classe) {
  if (classe == undefined) {
    classe = 'select2';
  }
  $('.'+classe).each(function(n, el) {
    var $el = $(el);
    var placeholder = $el.find('[value=""]').first().text()
      || $el.prop('placeholder')
      || $el.data('placeholder')
      || '-';

    if ($el.hasClass("select2-hidden-accessible")) {
      $el.select2('destroy');
    }

    $el.select2({
      placeholder: placeholder,
      language: "pt-BR",
      allowClear: true
    });
  });
}

// Submit em form com ctrl+s / cmd+s
if (typeof document.forms[2] !== 'undefined') {
  document.addEventListener("keydown", function(e) {
    if ((window.navigator.platform.match("Mac") ? e.metaKey : e.ctrlKey)  && e.keyCode == 83) {
      e.preventDefault();
      document.forms[2].submit();
    }
  }, false);
}
